import React, { useState } from 'react';
import { Collapse, Select } from 'antd';

import { MinusOutlined, DownloadOutlined, PlusOutlined, ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';
import { Bar, Line } from 'react-chartjs-2';
import './raktkoshDashboard.css';

const { Panel } = Collapse;
const { Option } = Select;
function BllodIssue() {
    const [activeTab, setActiveTab] = useState('check'); // Default active tab is 'check'
    const selectData = ["Sample collected", "Printed", "Accidental"];
    const accordionKeys = ['1', '2', '3']
    
    
    const handleTabClick = (tabKey,e) => {
        e.stopPropagation()
       
        setActiveTab(tabKey);
    };
    const barChartDataH = {
        labels: ['AB- ve', 'AB+ ve', 'A- ve', 'A+ ve', 'B- ve', 'B+ ve', 'Oh- ve', 'Oh+ ve', 'O- ve', 'O+ ve'],
        datasets: [
            {
                label: 'Blood Availability Today',
                data: [ 2319, 4786, 4324, 1342, 5253, 9734, 8375, 2585, 9963, 2585],
                backgroundColor: '#a8b7ca',
                borderWidth: 0,
            },
        ],
    }
    const barChartData = {
        labels: [ 'Delhi', 'Gujarat', 'Bihar', 'Andhra Pradesh', 'Maharashtra', 'Rajasthan', 'Uttar Pradesh', 'Kerla', 'West Bangal', 'Karnatka', 'North India', 'Bihar','Gorakhpur','Kerla', 'West Bangal', 'Karnatka', 'North India', 'Bihar','Gorakhpur'],
        datasets: [
            {
                label: 'Blood Availability Today',
                data: [2319,2319, 4786, 4324, 1342, 5253, 9734, 8375, 2585, 9963, 2585, 2876,3451, 9734, 8375, 2585, 9963, 2585, 2876,3451],
                backgroundColor: '#50C0FF',
                borderWidth: 0,
            },
        ],
    };

    const numLabels = barChartData.labels.length;
    const maxChartHeight = 50 + numLabels * 30; // Adjust 50 and 30 as needed for padding and label height
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: 'y',
        scales: {
            x: {
                display: false, // Hide x-axis
                position: 'none',
            },
            y: {
                ticks: {
                    beginAtZero: true, // Y axis starts at 0
                    stepSize: 50, // Adjust the step size as needed
                    autoSkip: false
                },
                display: true,
                position: 'left',
            },
        },
        plugins: {
            legend: {
                display: false, // Hide legend
            },
        },
        maxHeight: maxChartHeight, // Set maximum height for chart before scrolling is enabled
        datasets: {
            bar: {
                barPercentage: 0.7, // Adjust the thickness of the bars
                categoryPercentage: 0.6, // Adjust the spacing between the bars
            },
        },
    };

    const optionsH = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            y: {
                beginAtZero: true,
                autoSkip: false
            }
        },
        datasets: {
            bar: {
                barPercentage: 0.7, // Adjust the thickness of the bars
                categoryPercentage: 0.6, // Adjust the spacing between the bars
            },
        },
        plugins: {
            legend: {
                display: false, // Hide legend
            },
        },
    };



    return (
        <div>
            <div className='d-flex flex-column'>
                <div className='d-flex flex-column'>
                    <div>
                        <p className='stats mb-1'>Blood Issue</p>
                    </div>
                    <div className='d-flex gap-3 mb-4'>
                        <div className='col-12'>
                            <Collapse
                                expandIconPosition="right"
                                expandIcon={({ isActive }) => isActive ? <MinusOutlined /> : <PlusOutlined />}
                                className='accodianHeader'
                                defaultActiveKey={accordionKeys}
                            >
                                <Panel
                                 onClick={(e) => e.stopPropagation()}

header={
    <div className='d-flex ' >
        <span
            className={`d-flex bloodcollectiontabs${activeTab === 'check' ? ' active' : ''}`}
            onClick={(e) => handleTabClick('check',e)}
        >
            State wise <DownloadOutlined />
        </span>
        <span
            className={`d-flex bloodcollectiontabs${activeTab === 'check2' ? ' active' : ''}`}
            onClick={(e) => handleTabClick('check2',e)}
        >
            Issue Category Wise <DownloadOutlined />
        </span>
        <span
            className={`d-flex bloodcollectiontabs${activeTab === 'check3' ? ' active' : ''}`}
            onClick={(e) => handleTabClick('check3',e)}
        >
            Comp. Wise <DownloadOutlined />
        </span>
    </div>
}
                                    key="1" // Key for the panel
                                >
                                    <div className='chartScrollBody'>
                                        <div style={{ maxHeight: 'calc( 100% - 580px)' }}>
                                            <Bar data={barChartData} options={options} style={{ width: '50%', height: '100%' }} />
                                        </div>
                                    </div>
                                    <div>
                                        <p className='mb-0 d-flex gap-3 align-items-center justify-content-end filtersbtn'>
                                            <span>Count <ArrowUpOutlined /><ArrowDownOutlined /></span>
                                            <span>State <ArrowUpOutlined /><ArrowDownOutlined /></span>
                                        </p>
                                    </div>
                                </Panel>
                            </Collapse>
                        </div>
                    </div>
                </div>
                <div>

                    <div className='row'>
                        <div className='col-12'>

                            <Collapse expandIconPosition="right" expandIcon={({ isActive }) => isActive ? <MinusOutlined /> : <PlusOutlined />} defaultActiveKey={accordionKeys} className='accodianHeader' >
                                <Panel header={<span className='d-flex justify-content-between align-items-center stastHeaderTitlte'> Trends Issue <div> <Select
                                    style={{ width: 214 }}
                                    placeholder="select status"
                                    defaultValue={["Accidental"]}
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    {selectData.map((selectDatas, index) => {
                                        return (
                                            <Select.Option
                                                key={index}
                                                value={selectDatas}
                                            ></Select.Option>
                                        );
                                    })}
                                </Select> <DownloadOutlined onClick={(e) => e.stopPropagation()} /></div></span>} key="2">

                                    <div className='chartScrollBodyNew'>
                                        <div style={{ height: "280px" }}>
                                            <Bar data={barChartDataH} options={optionsH} style={{ width: '100%', height: '100%' }} />
                                        </div>
                                    </div>


                                </Panel>
                            </Collapse>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default BllodIssue;
